export default __webpack_public_path__ + "static/media/Q6.209593ba.jpg";